import { render } from "./DashboardStatsSummary.vue?vue&type=template&id=50e1b102"
import script from "./DashboardStatsSummary.vue?vue&type=script&lang=js"
export * from "./DashboardStatsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__